<template>
  <PopupBackground @click="$emit('close')">
    <div class="duplicate-console-popup smooth-shadow">
      <!-- Header -->
      <div class="header">
        <h3>Add Analysis</h3>
        <icon type="button" size="18" @click="$emit('close')">clear</icon>
      </div>

      <div class="contents">
        <div class="layerTypeContainer">
          <div class="iconContainer">
            <icon size="30">bubble_chart</icon>
          </div>
          <span class="title">
            Event Totals
          </span>
          <!-- <span class="subTitle">
            Analysis Layer
          </span> -->
          <p class="description">
            Calculate the total number of events at each static locations, e.g.
            Total Cancellations.
          </p>
          <Button
            type="primary"
            icon="add"
            text="Create Layer"
            @click="closeThisAnd('openEventTotalsPopup')"
          />
        </div>
        <div class="layerTypeContainer">
          <div class="iconContainer">
            <icon size="30">timelapse</icon>
          </div>
          <span class="title">
            Time Spent
          </span>
          <!-- <span class="subTitle">
            Analysis Layer
          </span> -->
          <p class="description">
            Calculate the total time spent between two events e.g. Booking TAT.
          </p>
          <Button
            disabled
            type="primary"
            icon="add"
            text="Create Layer (Coming Soon)"
            @click="closeThisAnd('openTimeSpentPopup')"
          />
        </div>
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/global/views/Button";

export default {
  components: {
    PopupBackground,
    Button,
  },
  props: {
    dashboard_id: Number,
    dashboard_name: String,
    dashboard_description: String,
  },
  data() {
    return {
      isRequestInProgress: false,
      layerName: "",
      eventColumn: null,
      eventValues: null,
      hasRadiusFilter: true,
      radius: "50",
    };
  },
  methods: {
    closeThisAnd(eventName) {
      this.$emit("close");
      this.$emit(eventName);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.duplicate-console-popup {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  width: 80%;
  max-width: 750px;
  padding: 25px;

  .header,
  .footer,
  .contents {
    padding: 10px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      font-weight: bold;
    }
  }

  .contents {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 25px;
    gap: 40px;

    .layerTypeContainer {
      display: flex;
      flex-direction: column;

      .iconContainer {
        background: var(--color-primary-light);
        align-self: flex-start;
        display: flex;
        padding: 10px;
        border-radius: 50%;
        margin-bottom: 10px;
        i {
          color: var(--color-primary);
        }
      }

      .title {
        font-size: 1.4em;
      }

      .subTitle {
        opacity: 0.7;
      }

      .description {
        flex: 1;
        margin-bottom: 50px;
      }

      button {
        align-self: flex-start;
      }
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
``
